// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__iC5z2","p":"Contact_p__ZqtsS"};